import { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import "./styles/scssstyles.css";
import ReactGA from 'react-ga4';

import {ApiPageContent, loader as apiPageLoader} from "./pages/apipage.js";
import {DatasetPageContent, loader as datasetPageLoader} from "./pages/datasetpage.js";
import {DatasetListPageContent, loader as datasetListPageLoader} from "./pages/datasetlistpage.js";
import {LandingPageContent, loader as landingPageLoader} from "./pages/landingpage.js";
//import {LearnPageContent, loader as learnPageLoader} from "./pages/learnpage.js";
//import {LearnListPageContent, loader as learnListPageLoader} from "./pages/learnlistpage.js";
import {MissionPageContent, loader as missionPageLoader} from "./pages/missionpage.js";
import {MissionListPageContent, loader as missionListPageLoader} from "./pages/missionlistpage.js";
import {SearchPageContent, loader as searchPageLoader} from "./pages/searchpage.js";
import {ErrorPage} from "./pages/errorpage.js";
import {StaticPageContent, loader as staticPageLoader} from "./pages/staticpage.js";
import {RegionPageContent, loader as regionPageLoader} from "./pages/regionpage.js";
import {SitemapPageContent} from "./pages/sitemappage.js";
import {GA_MEASUREMENT_ID} from "./constants.js";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.send('pageview');
  }, []);

  useEffect(() => {
    ReactGA.send('pageview');
  }, [location]);
};

const GoogleAnalyticsWrapper = ({ element }) => {
  usePageTracking();
  return element;
};

const router = createBrowserRouter([
    {
        path: "/",
        element: <GoogleAnalyticsWrapper element={<LandingPageContent />} />,
        loader: landingPageLoader,
    },
    {
        path: "/about",
        element: <GoogleAnalyticsWrapper element={<StaticPageContent />} />,
        loader: staticPageLoader("about"),
    },
    /*{
        path: "/contact-us",
        element: <GoogleAnalyticsWrapper element={<StaticPageContent />} />,
        loader: staticPageLoader("contactus"),
    },*/
    {
        path: "/api/doc/*",
        element: <GoogleAnalyticsWrapper element={<ApiPageContent />} />,
        loader: apiPageLoader,
        shouldRevalidate: () => false,
    },
    {
        path: "/dataset/:hcutId",
        element: <GoogleAnalyticsWrapper element={<DatasetPageContent />} />,
        loader: datasetPageLoader,
    },
    {
        path: "/datasetlist",
        element: <GoogleAnalyticsWrapper element={<DatasetListPageContent />} />,
        loader: datasetListPageLoader,
    },
    {
        path: "/downloading-and-acquiring",
        element: <GoogleAnalyticsWrapper element={<StaticPageContent />} />,
        loader: staticPageLoader("downloading-and-acquiring"),
    },
    /*{
        path: "/learn/:slug",
        element: <GoogleAnalyticsWrapper element={<LearnPageContent />} />,
        loader: learnPageLoader,
    },
    {
        path: "/learn/:pageNum/:pageLimit",
        element: <GoogleAnalyticsWrapper element={<LearnListPageContent />} />,
        loader: learnListPageLoader,
    },*/
    {
        path: "/learn-about-helio",
        element: <GoogleAnalyticsWrapper element={<StaticPageContent />} />,
        loader: staticPageLoader("learn-about-helio"),
    },
    {
        path: "/mission/:missionId",
        element: <GoogleAnalyticsWrapper element={<MissionPageContent />} />,
        loader: missionPageLoader,
    },
    {
        path: "/mission/:missionId/:pageNum/",
        element: <GoogleAnalyticsWrapper element={<MissionPageContent />} />,
        loader: missionPageLoader,
    },
    {
        path: "/mission/:missionId/:pageNum/:rawFacetRestricts",
        element: <GoogleAnalyticsWrapper element={<MissionPageContent />} />,
        loader: missionPageLoader,
    },
    {
        path: "/missionlist",
        element: <GoogleAnalyticsWrapper element={<MissionListPageContent />} />,
        loader: missionListPageLoader,
    },
    {
        path: "/open-science",
        element: <GoogleAnalyticsWrapper element={<StaticPageContent />} />,
        loader: staticPageLoader("openscience"),
    },
    {
        path: "/search/:query/:pageNum/",
        element: <GoogleAnalyticsWrapper element={<SearchPageContent />} />,
        loader: searchPageLoader,
    },
    {
        path: "/search/:query/:pageNum//",
        element: <GoogleAnalyticsWrapper element={<SearchPageContent />} />,
        loader: searchPageLoader,
    },
    {
        path: "/search/:query/:pageNum/:rawFacetRestricts?",
        element: <GoogleAnalyticsWrapper element={<SearchPageContent />} />,
        loader: searchPageLoader,
    },
    {
        path: "/region/:slug",
        element: <GoogleAnalyticsWrapper element={<RegionPageContent />} />,
        loader: regionPageLoader,
    },
    {
        path: "/region/:slug/:pageNum/",
        element: <GoogleAnalyticsWrapper element={<RegionPageContent />} />,
        loader: regionPageLoader,
    },
    {
        path: "/region/:slug/:pageNum/:rawFacetRestricts",
        element: <GoogleAnalyticsWrapper element={<RegionPageContent />} />,
        loader: regionPageLoader,
    },
    {
        path: "/terms-of-service",
        element: <GoogleAnalyticsWrapper element={<StaticPageContent />} />,
        loader: staticPageLoader("terms-of-service"),
    },
    {
        path: "/where-it-comes-from",
        element: <GoogleAnalyticsWrapper element={<StaticPageContent />} />,
        loader: staticPageLoader("where-it-comes-from"),
    },
    {
        path: "/sitemap",
        element: <GoogleAnalyticsWrapper element={<SitemapPageContent />} />,
        loader: staticPageLoader,
    },
    {
        path: "error",
        element: <GoogleAnalyticsWrapper element={<ErrorPage />} />,
        status: 404,
    },
    {
        path: "*",
        element: <GoogleAnalyticsWrapper element={<ErrorPage />} />,
    },
]);


function App() {
  return (
      <>
        <RouterProvider router={router} />
      </>
  );
}

export default App;
